"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _readOnlyError2 = _interopRequireDefault(require("@babel/runtime/helpers/readOnlyError"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _extension = _interopRequireDefault(require("../extensions/extension"));
// 1px * 1px png iamge
var NULL_IMAGE =
// eslint-disable-next-line max-len
'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAAXNSR0IArs4c6QAAAAtJREFUGFdjYAACAAAFAAGq1chRAAAAAElFTkSuQmCC';
var EntryPaint;
Entry.Painter = /*#__PURE__*/function () {
  function Painter(view) {
    (0, _classCallCheck2["default"])(this, Painter);
    this.view = view;
    this.cache = [];
    this.file = {
      id: Entry.generateHash(),
      name: '새그림',
      modified: false,
      mode: 'new' // new or edit
    };
    this.dropper = _extension["default"].getExtension('Dropper');
    this.isShow = false;
    this.clipboard = null;
    this._keyboardEvents = [];
    Entry.addEventListener('pictureImport', this.addPicture.bind(this));
    Entry.addEventListener('run', this.detachKeyboardEvents.bind(this));
    Entry.addEventListener('stop', this.attachKeyboardEvents.bind(this));
    this.importEntryPaint();
  }
  return (0, _createClass2["default"])(Painter, [{
    key: "importEntryPaint",
    value: function () {
      var _importEntryPaint = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee() {
        return _regenerator["default"].wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              EntryPaint = window.EntryPaint["default"];
              if (this.requestShow) {
                this.initialize();
              }
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function importEntryPaint() {
        return _importEntryPaint.apply(this, arguments);
      }
      return importEntryPaint;
    }()
  }, {
    key: "graphicsMode",
    get: function get() {
      return this.entryPaint.graphicsMode;
    }
  }, {
    key: "initialize",
    value: function initialize() {
      var _this = this;
      if (this.entryPaint || !EntryPaint) {
        this.requestShow = true;
        return;
      }
      this.isShow = true;
      this.entryPaint = EntryPaint.create({
        parent: this.view,
        mode: 'entry'
      });
      this.entryPaint.setDropper && this.entryPaint.setDropper(this.dropper);
      this.isImport = true;
      this.entryPaint.on('SNAPSHOT_SAVED', function (e) {
        if (!_this.isImport && Entry.stage.selectedObject) {
          Entry["do"]('editPicture', e, _this.entryPaint);
          _this.file.modified = true;
        }
        _this.isImport = false;
      });
      this.entryPaint.on('NEW_PICTURE', this.newPicture.bind(this));
      this.entryPaint.on('IMPORT_IMAGE', function () {
        Entry.dispatchEvent('openPictureImport');
      });
      this.entryPaint.on('SAVE_PICTURE', function () {
        _this.fileSave(false);
      });
      this.entryPaint.on('SAVE_NEW_PICTURE', function () {
        _this.file.mode = 'new';
        _this.fileSave(false);
      });
      this.entryPaint.on('FULL_SCREEN_ON', function () {
        _this.toggleFullscreen(true);
      });
      this.entryPaint.on('FULL_SCREEN_OFF', function () {
        _this.toggleFullscreen(false);
      });
      Entry.addEventListener('pictureSelected', this.changePicture.bind(this));
    }
  }, {
    key: "show",
    value: function show() {
      if (!this.isShow) {
        this.initialize();
      }
      this.realign && Entry.windowResized.detach(this.realign);
      this.realign = Entry.windowResized.attach(this.view, this.entryPaint.realign);
    }
  }, {
    key: "hide",
    value: function hide() {
      this.alertSaveModifiedPicture();
      this.entryPaint && Entry.windowResized.detach(this.realign);
    }
  }, {
    key: "newPicture",
    value: function newPicture() {
      var newPicture = {
        dimension: {
          height: 1,
          width: 1
        },
        fileurl: "".concat(Entry.mediaFilePath, "_1x1.png"),
        thumbUrl: "".concat(Entry.mediaFilePath, "_1x1.png"),
        name: Lang.Painter.new_picture,
        imageType: 'png'
      };
      newPicture.id = Entry.generateHash();
      if (this.file && this.file.objectId) {
        newPicture.objectId = this.file.objectId;
      }
      Entry.playground.addPicture(newPicture, true);
    }
  }, {
    key: "changePicture",
    value: function changePicture() {
      var picture = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var removed = arguments.length > 1 ? arguments[1] : undefined;
      if (this.file && this.file.id === picture.id) {
        if (!this.file.isUpdate) {
          Entry.stage.updateObject();
          this.file.isUpdate = true;
        }
        return;
      } else if (!this.file.modified) {
        this.afterModified(picture);
      } else {
        if (this.isConfirm) {
          return;
        }
        this.isConfirm = true;
        var wasRun = false;
        if (Entry.engine.state === 'run') {
          Entry.engine.toggleStop();
          wasRun = true;
        }
        if (removed) {
          this.updatePicture(picture);
        } else {
          this.alertSaveModifiedPicture(picture, wasRun);
        }
      }
      Entry.stage.updateObject();
      this.file.isUpdate = true;
    }
  }, {
    key: "updatePicture",
    value: function updatePicture() {
      var picture = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var wasRun = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var result = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      this.isConfirm = false;
      result ? this.fileSave(true) : this.file.modified = false;
      wasRun ? Entry.playground.injectPicture() : this.afterModified(picture);
      Entry.stage.updateObject();
    }
  }, {
    key: "alertSaveModifiedPicture",
    value: function alertSaveModifiedPicture(picture, wasRun) {
      var _this2 = this;
      if (!this.file.modified) {
        return;
      }
      Entry.modal.confirm(Lang.Menus.save_modified_shape).then(function (result) {
        _this2.updatePicture(picture, wasRun, result);
      });
    }
  }, {
    key: "afterModified",
    value: function afterModified(picture) {
      var file = this.file;
      file.modified = false;
      this.isImport = true;
      if (picture.id) {
        file.id = picture.id || Entry.generateHash();
        file.name = picture.name;
        file.mode = 'edit';
        file.objectId = picture.objectId;
        this.addPicture(picture, true);
      } else {
        file.id = Entry.generateHash();
        this.entryPaint.reset();
      }
      Entry.stateManager.removeAllPictureCommand();
    }
  }, {
    key: "getImageSrc",
    value: function getImageSrc(picture) {
      var _ref = picture || {},
        fileurl = _ref.fileurl;
      if (fileurl) {
        return fileurl;
      }
      var _ref2 = picture || {},
        _ref2$imageType = _ref2.imageType,
        imageType = _ref2$imageType === void 0 ? 'png' : _ref2$imageType,
        filename = _ref2.filename;
      return "".concat(Entry.defaultPath, "/uploads/").concat(filename.substring(0, 2), "/").concat(filename.substring(2, 4), "/image/").concat(filename, ".").concat(imageType === 'svg' ? 'svg' : 'png');
    }
  }, {
    key: "addPicture",
    value: function addPicture() {
      var picture = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var isChangeShape = arguments.length > 1 ? arguments[1] : undefined;
      picture.imageType = picture.imageType || 'png';
      var imageType = picture.imageType;
      var imageSrc = this.getImageSrc(picture);
      isChangeShape && (this.isImport = true);
      switch (imageType) {
        case 'png':
          this.entryPaint.addBitmap(imageSrc, {
            graphicsMode: this.isImport ? this.graphicsMode.BITMAP : ''
          });
          break;
        case 'svg':
          this.entryPaint.addSVG(imageSrc, {
            graphicsMode: this.isImport ? this.graphicsMode.VECTOR : ''
          });
          break;
        default:
          this.entryPaint.addBitmap(imageSrc, {
            graphicsMode: this.isImport ? this.graphicsMode.BITMAP : ''
          });
      }
    }
  }, {
    key: "_getImageType",
    value: function _getImageType() {
      if (this.entryPaint.mode === this.graphicsMode.VECTOR) {
        return 'svg';
      } else {
        return 'png';
      }
    }
  }, {
    key: "fileSave",
    value: function fileSave(taskParam) {
      if (!Entry.stage.selectedObject) {
        return;
      }
      var dataURL = this.entryPaint.getDataURL() || NULL_IMAGE;
      if (this.entryPaint.mode === this.graphicsMode.VECTOR) {
        this.file.svg = this.entryPaint.exportSVG();
      } else {
        delete this.file.svg;
      }
      this.file.ext = this._getImageType();
      var file = JSON.parse(JSON.stringify(this.file));
      Entry.dispatchEvent('saveCanvasImage', {
        file: file,
        image: dataURL,
        task: taskParam
      });
      this.file.isUpdate = false;
      this.file.modified = false;
    }
  }, {
    key: "attachKeyboardEvents",
    value: function attachKeyboardEvents() {
      this.detachKeyboardEvents();
      var events = this._keyboardEvents;
      var evt = Entry.keyPressed;
      evt && events.push(evt.attach(this, this._keyboardPressControl));
      evt = Entry.keyUpped;
      evt && events.push(evt.attach(this, this._keyboardUpControl));
    }
  }, {
    key: "detachKeyboardEvents",
    value: function detachKeyboardEvents() {
      var events = this._keyboardEvents;
      if (!events || !events.length) {
        return;
      }
      while (events.length) {
        var evt = events.pop();
        evt.destroy && evt.destroy();
      }
    }
  }, {
    key: "_keyboardUpControl",
    value: function _keyboardUpControl(e) {}
  }, {
    key: "_keyboardPressControl",
    value: function _keyboardPressControl(e) {}
  }, {
    key: "toggleFullscreen",
    value: function toggleFullscreen(isFullscreen) {
      var pictureView_ = Entry.playground.pictureView_;
      var $view = $(this.view);
      if (isFullscreen !== true && $view.hasClass('fullscreen') || isFullscreen === false) {
        pictureView_.appendChild(this.view);
        $view.removeClass('fullscreen');
        if (this.fullscreenButton) {
          this.fullscreenButton.setAttribute('title', Lang.Painter.fullscreen);
          this.fullscreenButton.setAttribute('alt', Lang.Painter.fullscreen);
        }
      } else {
        document.body.appendChild(this.view);
        $view.addClass('fullscreen');
        if (this.fullscreenButton) {
          this.fullscreenButton.setAttribute('title', Lang.Painter.exit_fullscreen);
          this.fullscreenButton.setAttribute('alt', Lang.Painter.exit_fullscreen);
        }
      }
      this.entryPaint && this.entryPaint.realign();
    }
  }, {
    key: "clear",
    value: function clear() {
      this.toggleFullscreen(false);
    }
  }, {
    key: "undo",
    value: function undo() {
      this.entryPaint.undo();
    }
  }, {
    key: "redo",
    value: function redo() {
      this.entryPaint.redo();
    }
  }]);
}();